/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import BossDialog from "../../components/BossDialog";
import { Form, FormElement } from "@progress/kendo-react-form";
import * as API from "../../framework/API/api"
import { BUCKET_CONFIG_TYPE, ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";
import ToastNotification from "../../components/ToastNotification";


export const PriceCodeEditForm = (props) => {

  const lang = useTranslation();
  const blankDataItem = {
    ...props?.item,
    SID: props?.item?.SID ?? 0,
    Description: props?.item?.copy ? 'copy of ' + props?.item?.Description : props?.item?.Description ?? '',
    Code: props?.item?.Code ?? '',
    Price: props?.item?.Price ?? '',
    Currency: props?.item?.Currency ?? {},
    Days: props?.item?.Days ?? 0,
    Archive: props?.item?.Archive ?? false,
    Duration: props?.item?.Duration ? props?.item?.Duration : 0,
    IsDefault: props.item.IsDefault ?? false,
  }

  const [dataItem, setDataItem] = useState(blankDataItem);
  const [currency, setCurrency] = useState([]);

  useEffect(() => {
    loadcombo();
  }, [])

  const loadcombo = async () => {
    var currencyRes = await API.getDataLookup(ENTITYNAME.Currency, { sort: { Description: 1 } });
    setCurrency(currencyRes.data);
  }
  //function to check the validation in form
  function validationCheck() {

    if (dataItem.Description == undefined || dataItem.Description.trim().length == 0 || dataItem.Description == "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
      return false;
    }
    if (dataItem.Code == undefined || dataItem.Code.trim().length == 0 || dataItem.Code == "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_code_error_message });
      return false;
    }
    if (dataItem.Price == undefined || dataItem.Price.trim().length == 0 || dataItem.Price == "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_price_error_message });
      return false;
    }
    return true;
  }

  const handleSubmit = async (e) => {

    if (validationCheck()) {
      const saveData = {
        _id: dataItem?._id,
        SID: dataItem?.SID ?? 0,
        Description: dataItem?.Description,
        Code: dataItem?.Code,
        Price: dataItem?.Price,
        Currency: dataItem?.Currency && Object.keys(dataItem?.Currency).length > 0 ? {
          _id: dataItem?.Currency?._id,
          Description: dataItem?.Currency?.Description,
          IsDefault: dataItem?.Currency?.IsDefault
        } : {},
        Days: dataItem?.Days,
        Archive: dataItem?.Archive ?? false,
        Duration: dataItem?.Duration,
        IsDefault: dataItem?.IsDefault ?? false,
        checkDuplicate: true,
        query: [["Description", "=", dataItem.Description]],
      }
      console.log(saveData);

      let res = await API.saveData(ENTITYNAME.PRICECODE, saveData);
      if (res.success) {
        let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.PRICE_CODE, data: res.data, message: res.message };
        API.SaveLogs(logData);
        utility.deleteLocalStorageItem(ENTITYNAME.PRICECODE);
        props.cancelEdit();
        props.refresh(res.data);
      }
      else {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      }
    }
  }

  const onChangeForm = (e) => {

    if (e.target.name == "Archive") {
      setDataItem({ ...dataItem, Archive: !dataItem.Archive });
    } else if (e.target.name == "IsDefault") {
      setDataItem({ ...dataItem, IsDefault: !dataItem.IsDefault });
    } else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }

  }

  return (
    <BossDialog
      title={props.item.SID > 0 ? props.item.Description : lang.create_price_code_dialog_title}
      onClose={props.cancelEdit}
      width={"770px"}
    >
      <div className="row align-items-center">
        <div className="col" >
          <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
        </div>
        {props.item?._id && (
          <div className="col-auto d-flex align-items-center">
            <label className="mb-0 mr-2">{lang.price_code_csid_label}:</label>
            <div className="d-flex align-items-center px-2" disabled style={{ width: "170px", height: "30px", border: "1px solid rgb(197 200 201 / 88%)", borderRadius: "4px", backgroundColor: "#eaeef1", fontSize: "13px" }} >{props.item?.CSID}</div>
          </div>
        )}
      </div>
      <Form
        initialValues={dataItem}
        render={(formRenderProps) => (
          <FormElement>
            <div className="row mt-2">
              <div className="col-12">
                <div className="row">
                  <div className="col-6">
                    <label>{lang.description_label} *</label>
                    <input
                      name={"Description"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.Description}
                    />
                  </div>
                  <div className="col-6">
                    <label>{lang.code_label} *</label>
                    <input
                      name={"Code"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.Code}
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-6">
                    <label>{lang.price_label} *</label>
                    <input
                      name={"Price"}
                      type="Number"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.Price}
                    />
                  </div>
                  <div className="col-6" >
                    <label>{lang.currency_label}</label>
                    <DropDownList
                      style={{ backgroundColor: "white" }}
                      data={currency}
                      name="Currency"
                      textField="Description"
                      dataItemKey="_id"
                      value={dataItem.Currency}
                      onChange={onChangeForm}
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-6" >
                    <label>{lang.time_unit_label}</label>
                    <input
                      name="Days"
                      className="form-control form-control-sm"
                      value={dataItem.Days}
                      type="number"
                      onChange={onChangeForm}
                      min={0}
                    />
                  </div>
                  <div className="col-6">
                    <label>{lang.rental_duration_label}</label><br />
                    <input
                      name="Duration"
                      className="form-control form-control-sm"
                      value={dataItem.Duration}
                      type="number"
                      onChange={onChangeForm}
                    />
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-2" >
                    <input type={"checkbox"} name={"Archive"}
                      onChange={(e) => onChangeForm(e)}
                      value={dataItem.Archive}
                      checked={dataItem.Archive} />
                    <label className="ml-1">{lang.archive}</label>
                  </div>
                  <div className="col-2">
                    <input
                      type={"checkbox"}
                      name={"IsDefault"}
                      onChange={(e) => onChangeForm(e)}
                      value={dataItem.IsDefault}
                      checked={dataItem.IsDefault}
                    />
                    <label className="ml-1">{lang.is_default_label}</label>
                  </div>
                </div>
              </div>
            </div>
          </FormElement>
        )}
      />

    </BossDialog>)
};